import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UpgradeModal from './UpgradeModal';

const ProtectedRoute = ({ children, allowedRoles = [], requiresPro = false }) => {
  const { user, loading, isFreePlan } = useAuth();
  const [showUpgrade, setShowUpgrade] = useState(true);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0A1929 0%, #1E3A5F 100%)' }}>
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Block free-plan clients from PRO+ features
  if (requiresPro && isFreePlan && user.role === 'client') {
    return (
      <div className="flex items-center justify-center h-full min-h-[60vh]">
        <div className="text-center p-8">
          <div className="text-6xl mb-4">🔒</div>
          <h2 className="text-2xl font-bold text-white mb-2">PRO+ Feature</h2>
          <p className="text-gray-400 mb-6">This feature is available on the PRO+ plan. Upgrade to unlock.</p>
          <button
            onClick={() => setShowUpgrade(true)}
            className="px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-xl hover:from-[#FFD700] hover:to-[#D4AF37] transition-all"
            data-testid="route-upgrade-btn"
          >
            Upgrade to PRO+
          </button>
        </div>
        <UpgradeModal isOpen={showUpgrade} onClose={() => setShowUpgrade(false)} />
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
